import { Link } from "react-router-dom";
import { Home } from "../pages/home/Home";
import { ContactUs } from "../pages/contactus/ContactUs";
import Layout from "../components/Layout";
import { SignOut } from "../pages/sign-out/SignOut";
import { LandingPage } from "../pages/landing-page/LandingPage";
import Callback from "../pages/callback";
import SecureRoute from "../components/SecureRoute";
import { MenuItem } from "react-pro-sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faArrows,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { UserProfile } from "../components/UserProfile";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import Footer from "../components/Footer";
import { NewLogInPage } from "../pages/log-in/NewLogInPage";
import { DisableMFA } from "../pages/log-in/DisableMFA";
import { MFASetUp } from "../pages/log-in/MFASetUp";
import { TSRedirect } from "../TSRedirect";
import { RouterError } from "../components/RouterError";
import { GenericLiveboardEmbed } from "../components/GenericLiveboardEmbed";
import { B1 } from "../pages/demos/mba/B1";
import { CelinkFinancialModeling } from "../pages/demos/celink/CelinkFinancialModeling";
import { Test } from "../Test";
import { ChangeLog } from "../changeLog";
import { TermsOfService } from "../termsOfService";
import { PrivacyPolicy } from "../privacyPolicy";
import { Status } from "../Status";
//import { Demo } from "./pages/demos/prmg/demo";

const InSessionSidebarMenu = () => {
  return (
    <>
      <MenuItem>
        <Link to="landingpage">
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrows} />
            Product
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to="contactus">
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEnvelope} />
            Contact Us
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to="signout">
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
            Log Out
          </div>
        </Link>
      </MenuItem>
    </>
  );
};

export const mainRoutes = {
  element: <Layout breakPoint={DefaultSidebarBreakpoint} />,
  children: [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "callback",
      element: <Callback />,
    } /* 
    {
      path: "signup",
      element: <SignUp />,
    }, */,
    {
      path: "contactus",
      element: <ContactUs />,
    },
    {
      path: "test",
      element: <SecureRoute groups={[]} element={<Test />} />,
    },
    {
      path: "login",
      element: <NewLogInPage />,
    },
    {
      path: "patch-notes",
      element: <ChangeLog />,
    },
    {
      path: "terms-of-service",
      element: <TermsOfService />,
    },
    {
      path: "privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "status",
      element: <Status />,
    },
    {
      path: "financialmodeldemo",
      element: (
        <SecureRoute groups={[]} element={<CelinkFinancialModeling />} />
      ),
    },
    {
      path: "tsid/:LiveboardId",
      element: <TSRedirect />,
    },
    {
      path: "/error",
      element: <RouterError />,
    },
    {
      path: "retailanalyticsdemo",
      element: (
        <SecureRoute
          groups={["DemoAnalytics"]}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={true}
              description="Retail Lending Analytics"
              guid="31f70534-e614-4832-8888-5b99f92c4e16"
              orgID={1977935901}
            />
          }
        />
      ),
    },
    {
      path: "/mb/analysis",
      element: <B1 />,
    },
  ],
};

export const landingPageRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      sidebarMenu={<InSessionSidebarMenu />}
      navMenu={<UserProfile />}
      footer={<Footer displayVersion={true} />}
    />
  ),
  children: [
    {
      path: "landingpage",
      element: <LandingPage />,
    },
    {
      path: "signout",
      element: <SignOut />,
    },
    {
      path: "mfasetup",
      element: <MFASetUp onSetupSuccess={() => {}} alreadyAcceptedMFA={true} />,
    },
    {
      path: "disablemfa",
      element: <DisableMFA />,
    },
  ],
};
